import React from 'react';
import Text from '../text';
import { SIZES, APPEARANCES, TYPES, ALIGN } from './constants';
const Paragraph = ({
  children,
  size = SIZES.medium,
  appearance = APPEARANCES.highEmphasis,
  align = ALIGN.left,
  // @ts-ignore
  weight = null,
  isClipped = false,
  isUppercase = false,
  isHighlighted = false,
}) => (
  <Text
    type={TYPES.paragraph}
    size={size}
    appearance={appearance}
    align={align}
    // @ts-ignore Type 'null' is not assignable to type 'AnyString | ValueOf<{ readonly light: "light";...
    weight={weight}
    isClipped={isClipped}
    isUppercase={isUppercase}
    isHighlighted={isHighlighted}
  >
    {children}
  </Text>
);

export default Paragraph;
